import { ProjectTypeEnum } from '@/enums';
import type { IProject, ProjectType } from '@/types';

/**
 * Check if a project is a movie/film project
 * @param project - Project object (IProject or ProjectType)
 * @returns true if movie, false if series
 */
export const isMovieProject = (project: Pick<IProject | ProjectType, 'type' | 'episodes_qty'> | undefined): boolean => {
    if (!project) return true; // Default to movie if no project
    if (project.type) {
        return project.type === ProjectTypeEnum.MOVIE;
    }
    // Fallback: episodes_qty === '1' means movie (for backward compatibility)
    return project.episodes_qty === '1';
};

/**
 * Get the project type enum value
 * @param project - Project object (IProject or ProjectType)
 * @returns ProjectTypeEnum.MOVIE or ProjectTypeEnum.SERIES
 */
export const getProjectType = (project: IProject | ProjectType | undefined): ProjectTypeEnum => {
    if (!project) return ProjectTypeEnum.MOVIE;
    if (project.type) {
        return project.type;
    }
    // Fallback: episodes_qty > '1' means series
    return project.episodes_qty !== '1' ? ProjectTypeEnum.SERIES : ProjectTypeEnum.MOVIE;
};
